import { TABLE_VIEW_BUTTONS_TEST_ID } from './commonConfig';
import TableViewToggles, { TableViewTogglesViewType } from '@rio-cloud/rio-uikit/TableViewToggles';
import { useIntl } from 'react-intl';
import { useAppDispatch, useAppSelector } from '../../../configuration/setup/hooks';
import { getTableViewType, viewSlice } from '../reducers/viewSlice';

export const TableViewOptions = () => {
    const viewType = useAppSelector(getTableViewType);
    const dispatch = useAppDispatch();
    const intl = useIntl();

    const handleViewTypeChange = (newViewType: TableViewTogglesViewType) =>
        dispatch(viewSlice.actions.setTableViewType(newViewType));

    return (
        <TableViewToggles
            data-testid={TABLE_VIEW_BUTTONS_TEST_ID}
            initialViewType={viewType}
            tableViewLabel={intl.formatMessage({
                id: 'intl-msg:common-message.table.viewToggle.table',
            })}
            singleCardViewLabel={intl.formatMessage({
                id: 'intl-msg:common-message.table.viewToggle.cards',
            })}
            multiCardsViewLabel={intl.formatMessage({
                id: 'intl-msg:common-message.table.viewToggle.list',
            })}
            onViewTypeChange={handleViewTypeChange}
        />
    );
};
